import React from 'react';

import {
  BrokenGlassIcon,
  BrokenGlassIconV2,
  BrokenPoleIcon,
  BrokenPoleIconV2,
  FadedAdsIcon,
  FadedAdsIconV2,
  GarbageOverflowIcon,
  GarbageOverflowIconV2,
  GoodConditionIcon,
  GoodConditionIconV2,
  GraffitiIcon,
  GraffitiIconV2,
  LightsOutIcon,
  LightsOutIconV2,
  OtherIcon,
  OtherIconV2,
  PersonalPropertyIcon,
  PersonalPropertyIconV2,
  SignMissingFadedIcon,
  SignMissingFadedIconV2,
} from '../components/event_details/EventTags/TagIcons';

// TODO: Temporary solution for SacRT-specific tag icons.
// This should be replaced with a more generic tag icon system stored in backend

export const TAG_CONFIGS = {
  'ev:2230': {
    icon: SignMissingFadedIcon,
    iconActive: SignMissingFadedIconV2,
    label: 'Sign missing/faded',
  },
  'ev:2238': {
    icon: FadedAdsIcon,
    iconActive: FadedAdsIconV2,
    label: 'Faded / missing advertisements',
  },
  'ev:2231': {
    icon: BrokenPoleIcon,
    iconActive: BrokenPoleIconV2,
    label: 'Pole is broken / missing',
  },
  'ev:2232': {
    icon: BrokenGlassIcon,
    iconActive: BrokenGlassIconV2,
    label: 'Broken glass',
  },
  'ev:2233': {
    icon: GraffitiIcon,
    iconActive: GraffitiIconV2,
    label: 'Graffiti',
  },
  'ev:2234': {
    icon: LightsOutIcon,
    iconActive: LightsOutIconV2,
    label: 'Lights out',
  },
  'ev:2235': {
    icon: GarbageOverflowIcon,
    iconActive: GarbageOverflowIconV2,
    label: 'Garbage overflow',
  },
  'ev:2236': {
    icon: GoodConditionIcon,
    iconActive: GoodConditionIconV2,
    label: 'Good condition',
  },
  'ev:2237': {
    icon: OtherIcon,
    iconActive: OtherIconV2,
    label: 'Other',
  },
  'ev:2271': {
    icon: PersonalPropertyIcon,
    iconActive: PersonalPropertyIconV2,
    label: 'Unattended Personal Property',
  },
} as const;

// Returns icon component based on active state
export function getTagIconComponent(
  tagValue: string,
  isActive = false,
): React.FC<React.SVGProps<SVGSVGElement>> | undefined {
  const config = TAG_CONFIGS[tagValue];
  if (!config) return undefined;

  return isActive ? config.iconActive : config.icon;
}

export function getTagLabel(tagValue: string): string {
  return TAG_CONFIGS[tagValue]?.label || tagValue;
}
